import React, {Component} from 'react'

import { connect } from 'react-redux'
import SettingsFilterZip from './components/Settings/SettingsFilterZip'

import {
  setTitle
} from 'common/redux/root'
import { fetchAgentMvipSettings } from '../redux/settings.js'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsLocationContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {saveable: false}
  }

  componentWillMount() {
    this.props.dispatch(setTitle("Disabled Zip Codes"))
    this.props.dispatch(fetchAgentMvipSettings())
  }

  render() {
    return <SettingsFilterZip {...this.props} />
  }

}

export default connect((state) => ({ auth: state.auth, settings: state.settings }), mapDispatchToProps)(SettingsLocationContainer)
